import facePageStyles from '../views/facePageStyles';
import assocGroupStyles from './assocGroupStyles';

const taskAssocGroupStyles = (theme) => ({
  ...facePageStyles(theme),
  ...assocGroupStyles(theme),
  taskCheckBox: {
    '&$taskCheckBox_small': {
      '& $taskCheckBox_container': {
        width: '36px',
        height: '36px',
        lineHeight: '36px',
        fontSize: '19px',
      },
    },
    '& $taskCheckBox_container': {
      width: '50px',
      height: '50px',
      lineHeight: '50px',
      borderRadius: '50%',
      overflow: 'hidden',
      background: '#dce3e6',
      fontSize: '25px',
      color: 'rgba(12,13,13,0.64)',
      outline: 0,
      '&:hover': {
        '& $taskCheckBox_checkbox': {
          display: 'inline-flex',
        },
        '& $taskCheckBox_activityIcon': {
          display: 'none',
        },
      },
      '&.isOverdue': {
        color: '#ff2020',
      },
      '&.isUrgent': {
        color: '#ff9900',
      },
      '&.isNotUrgent': {
        color: '#20d486',
      },
      '&.isCompleted': {
        color: '#2046d4',
      },
      '&.isCanceled': {
        color: '#aaaaaa',
      },
      '& $taskCheckBox_checkbox': {
        display: 'none',
        // width: "200%",
        fontSize: '20px',
        marginLeft: '10px',
        marginTop: '1px',
        // the following four are shared by "taskCheckBox taskCheckBox_container taskCheckBox_activityIcon"
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        '&>i': {
          textDecoration: 'none',
        },
      },
      '& $taskCheckBox_activityIcon': {
        display: 'inline-flex',
        width: '100%',
        // the following should be shared by "taskCheckBox taskCheckBox_container taskCheckBox_checkbox"
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
  },
  taskCheckBox_small: {},
  taskCheckBox_container: {},
  taskCheckBox_checkbox: {},
  taskCheckBox_activityIcon: {},
});

export default taskAssocGroupStyles;
